
import Vue from 'vue';
import datepicker from 'jquery-ui/ui/widgets/datepicker';
window.$ = window.jQuery = require('jquery');
import 'jquery-validation';

Vue.component('signup-vue', {
  methods: {
    showPassword(ele) {
      const passwordField = ele.previousElementSibling;
      passwordField && passwordField.setAttribute('type', 'text');
    },

    hidePassword(ele) {
      const passwordField = ele.previousElementSibling;
      passwordField && passwordField.setAttribute('type', 'password');
    },
  },

  mounted() {
    const dateField = this.$el.querySelector('#field-date');
    $(dateField).datepicker({
      changeMonth: true,
      changeYear: true,
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(),
      dateFormat: 'yy-mm-dd'
    });

    $.validator.addMethod(
      'complexPassword',
      function(value, element) {
        if (value.trim() !== '') {
          return /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{8,}$/.test(value);
        }
        return true;
      },
      'Password must be at least 8 characters and include at least one uppercase letter, one number, and one special character.'
    );

    $.validator.addMethod(
      'alphaWithSpacesPassword',
      function(value, element) {
        // Count the number of spaces in the string
        const spaceCount = (value.match(/ /g) || []).length;
        return /^[a-zA-Z!@#$%^&*(),.?":{}|<>'\\[\]_\-; ~`\/=]{2,30}$/.test(value) && spaceCount <= 3;
      },
      'Please enter valid value'
    );
    $.validator.addMethod(
      'zipcodeLength',
      function(value, element) {
        if (value.trim() !== '') {
          return /^\s*.{4,12}\s*$/.test(value);
        }
        return true;
      },
      'Zip code should be minimum 4 and maximum 12 characters long'
    );
    const submitButton = this.$el.querySelector('#edit-submit');
    if (submitButton) {
      submitButton.addEventListener('click', () => {
        const form = $('#user-register-form,#user-form');
        form.validate({
          errorClass: 'js-error',
          // Validation rules and messages for each field
          rules: {
            'field_first_name[0][value]': {
              required: true,
              alphaWithSpacesPassword: true,
              minlength: 2,
            },
            'field_last_name[0][value]': {
              required: true,
              alphaWithSpacesPassword: true,
              minlength: 2,
            },
            mail: {
              required: true,
              email: true,
            },
            'field_zip_code[0][value]': {
              zipcodeLength: true
            },
            'pass[pass1]': {
              minlength: 8,
              complexPassword: true,
            },
            'pass[pass2]': {
              complexPassword: true,
              equalTo: 'input[name="pass[pass1]"]'
            }
          },

          messages: {
            mail: {
              email: 'Please enter a valid email address',
            },
            'pass[pass1]': {
              minlength: 'Password must be at least 8 characters long',
              complexPassword: 'Password must be at least 8 characters and include at least one uppercase letter, one number, and one special character.'
            },
            'pass[pass2]': {
              equalTo: 'Password does not match'
            }
          },
        });
        if (form.valid()) {
          form.submit(function() {
            const dateFieldDiv = document.querySelector('.sign-up__date');
            const dateInputField = dateFieldDiv.querySelector('#field-date');
            const selectedValueNew = document.querySelector('.sign-up__connection span').innerText;
            if (selectedValueNew !== 'I have PD') {
              dateInputField.value = '';
            }
          });
        }
      });
    }
    document.addEventListener('DOMContentLoaded', function() {
      var connectionDropdown = document.getElementById('edit-field-connection-to-disease');
      var dateFieldset = document.querySelector('.sign-up__date');
      function updateSignUpDisplay() {
        const signUpConnectionDiv = document.querySelector('.sign-up__connection');
        const selectedValue = connectionDropdown.querySelector('span').innerText;
        const selectedLiValue = selectedValue === 'I have PD';
        dateFieldset.classList.toggle('toggle-sign-up-date-list', !selectedLiValue);
        signUpConnectionDiv.classList.toggle('sign-up-date-full-width', !selectedLiValue);
      }
      function handleConnectionDropdownClick() {
        updateSignUpDisplay();
      }
      updateSignUpDisplay();
      connectionDropdown.addEventListener('click', handleConnectionDropdownClick);
    });
  },
});
